import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuote = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 39,
	height: 27,
	viewBox: "0 0 39 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M9 0a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z" }), /* @__PURE__ */ _jsx("path", { d: "M18 7c0 10-4.8 17.2-13.4 20L3 22.4C9.4 20.2 13 15.6 13 8Z" })]
	}), /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		transform: "translate(21 0)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M9 0a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z" }), /* @__PURE__ */ _jsx("path", { d: "M18 7c0 10-4.8 17.2-13.4 20L3 22.4C9.4 20.2 13 15.6 13 8Z" })]
	})]
});
export default SvgQuote;
